'use strict';

module.exports = {
  __init__: [ 'previewSupport' ],
  previewSupport: [ 'type', require(216) ]
};
